import { PURCHASE_TIER_ACTION } from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'

export const purchaseTierProfile = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    case PURCHASE_TIER_ACTION.WITH_POINTS:
      return mergeToNewObject(state, {
        isProcessing: true,
        tier: null,
        error: {}
      })

    case PURCHASE_TIER_ACTION.WITH_POINTS_SUCCESS:
      return mergeToNewObject(state, {
        isProcessing: false,
        tier: payload,
        error: {}
      })

    case PURCHASE_TIER_ACTION.WITH_POINTS_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        tier: null,
        error: {
          purchaseWithPoints: true
        }
      })

    case PURCHASE_TIER_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    default:
      return state
  }
}

const INITIAL_STATE = {
  error: {},
  isProcessing: false,
  tier: null
}

export const PURCHASE_TIER_PROFILE_DISPATCH = {
  ERROR: 'error'
}
